// import components
import { IconButton } from '@mui/material';

// import styles
import {
  CategoryChevronIcon,
  CategoryCount,
  HeaderLabel
} from '../BacklogGrid/BacklogGrid.styles';

// import types
import type { BacklogCategoryLabelProps } from './BacklogCategoryLabel.types';

/**
 * The inner content of a task-category header: the fold chevron (or a static marker for a category that
 * does not fold, like outside treatment), the category name, and its task count. Shared by the weeks
 * grid and the week-detail so a category reads the same in both. The caller supplies the surrounding
 * label cell, since the grid lays it out as a data-grid cell and the detail as a CSS-grid column.
 */
const BacklogCategoryLabel = ({
  label,
  count,
  markerIconType = 'clipboard-list',
  fold
}: BacklogCategoryLabelProps) => {
  'use memo';

  return (
    <>
      {fold ? (
        // Only the chevron is a control; the label beside it is a heading.
        <IconButton
          size="small"
          onClick={fold.onToggle}
          aria-expanded={fold.isExpanded}
          aria-label={fold.ariaLabel}
        >
          <CategoryChevronIcon
            type={fold.isExpanded ? 'chevron-down' : 'chevron-right'}
            color="action"
          />
        </IconButton>
      ) : (
        // A category that does not fold shows a static marker where the chevron would sit.
        <CategoryChevronIcon type={markerIconType} color="action" />
      )}
      <HeaderLabel variant="body1" noWrap>
        {label}
      </HeaderLabel>
      <CategoryCount>({count})</CategoryCount>
    </>
  );
};

export default BacklogCategoryLabel;
